import {
    HSProperties,
    HubspotProperties,
    PrepareHSPropertiesParams,
    SentryErrorType,
} from "@smile2impress/attraction-utils";
import {
    prepareDefaultHSProperties,
    getUtmQueryParamsFromCookies,
} from "@smile2impress/attraction-utils";

import { HubspotCreationSource } from "constants/enum";

import { reportToSentry } from "./reportToSentry";

type HSBusinessParams = {
    hasPassUuid?: boolean;
};

const applyExtraParams = (
    properties: HSProperties & Record<string, unknown>,
    extra?: HSBusinessParams
) => {
    const next = { ...properties };

    if (extra?.hasPassUuid) {
        next[HubspotProperties.CREATION_SOURCE] = HubspotCreationSource.WEBSITE;
    }

    return next;
};

export const prepareHSProperties = (
    params: PrepareHSPropertiesParams,
    extraParams?: HSBusinessParams
): HSProperties & Record<string, unknown> => {
    const { pathname } = window?.location;
    if (pathname && !params.submitPage) {
        params.submitPage = pathname;
    }
    const utmQueryParams = getUtmQueryParamsFromCookies();

    const defaultProperties = prepareDefaultHSProperties(params);

    if (!params.submitPage) {
        reportToSentry({
            error: SentryErrorType.NO_SUBMIT_PAGE,
            level: "warning",
            extra: {
                sourcePage: defaultProperties[HubspotProperties.SOURCE_PAGE],
                openPage: defaultProperties[HubspotProperties.OPEN_PAGE],
                pathname,
                asPath: params.asPath,
                gclid: defaultProperties[HubspotProperties.GOOGLE_ADS_ID],
                clinic: params.clinic,
                locale: params.locale,
                ...utmQueryParams,
            },
        });
    }

    if (extraParams) {
        return applyExtraParams(defaultProperties, extraParams);
    }
    return defaultProperties;
};
